// <s-sticky-atc> is the pinned mobile add bar on product pages.
// It stays hidden while the page's main Add button ([data-main-add]) is on screen, so shoppers
// never see two Add buttons at once, and slides in once that button scrolls out of view.
class SStickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const form = this.closest('form');
    const target = form?.querySelector('[data-main-add]');
    this.#setVisible(false);
    if (!target || !('IntersectionObserver' in window)) {
      this.#setVisible(true);
      return;
    }
    this.#observer = new IntersectionObserver(([entry]) => {
      this.#setVisible(!entry.isIntersecting);
    }, { threshold: 0 });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
    if (visible) this.removeAttribute('aria-hidden');
    else this.setAttribute('aria-hidden', 'true');
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', SStickyAtc);
